export default __webpack_public_path__ + "static/jerrel-4b2f838a3d3d54207ffa3fbd461f3f08.png";